import React, { Component } from 'react'
import {Alert,Label,Row,Col,Table,Input,Button,Spinner,Modal,ModalHeader,ModalBody,ModalFooter,FormGroup} from 'reactstrap'
import {connect } from 'react-redux';
import {getMainData,addMyData} from "../../Redux/ducks/mainReducer";
import {Redirect} from 'react-router-dom';
import ReactJsAlert from "reactjs-alert"

export class ActiveLoans extends Component {
    state={
        isLoading:false,
        btnDisabled:false,
        msg:null,
        mainData:null,
        searchAction:null,
        nameSearch:null,
        redirect:false,
        redirectSelectedID:null,
        suspendModal:false,
        selectedLoan:null,
        suspendReason:'',
        alertStatus:false,
        alertType:"error",
        alertTitle:null
    }

    componentDidMount(){
        this.setState({isLoading:true})
        this.props.getMainData("ACTIVELOAN_DATA")
    }

    componentDidUpdate(prevProps){
        const{userData,msg,userDataStatus,addMyDataStatus} = this.props;
        if(userDataStatus !== prevProps.userDataStatus){
            if(userDataStatus===true){
                this.setState({isLoading:false,msg:msg,mainData:userData})
            }else{
                this.setState({isLoading:false,mainData:null,msg:msg})
            }
        }

        if(addMyDataStatus !== prevProps.addMyDataStatus){
            if(addMyDataStatus===true){
                this.setState({btnDisabled:false,suspendModal:false,selectedLoan:null,suspendReason:'',alertStatus:true,alertType:"success",alertTitle:msg,isLoading:true})
                this.props.getMainData("ACTIVELOAN_DATA")
            }else if(addMyDataStatus===false){
                this.setState({btnDisabled:false,alertStatus:true,alertType:"error",alertTitle:msg})
            }
        }
    }

    setValue = e =>{
        this.setState({[e.target.name]:e.target.value})
    }

    setSearchValue = (e) =>{
        this.setState({nameSearch:e.target.value,searchAction:e.target.id})
    }

    openSuspendModal = (loan) =>{
        this.setState({suspendModal:true,selectedLoan:loan,suspendReason:''})
    }

    closeSuspendModal = () =>{
        this.setState({suspendModal:false,selectedLoan:null,suspendReason:''})
    }

    suspendLoan = () =>{
        const {selectedLoan,suspendReason} = this.state
        if(selectedLoan === null){
            this.setState({alertStatus:true,alertType:"error",alertTitle:"Select loan to suspend"})
        }else if(suspendReason.trim() === ""){
            this.setState({alertStatus:true,alertType:"error",alertTitle:"Enter reason for suspending this loan"})
        }else{
            const data = new FormData();
            data.append("loanID",selectedLoan.id);
            data.append("reason",suspendReason);
            this.setState({btnDisabled:true})
            this.props.addMyData(data,"SUSPEND_LOAN")
        }
    }

    renderLoanRow = (values,myNo,i) => (
        <tr key={i}>
            <td><Button color="danger" size="sm" onClick={() => this.openSuspendModal(values)}>Suspend</Button></td>
            <td>{myNo}</td>
            <th scope="row">{values.loanID}</th>
            <td>{values.member.firstName+" "+values.member.lastName}</td>
            <td>{values.member.clubNumber}</td>
            <td>{values.paytype == null? "": values.paytype.name}</td>
            <td>{values.period}</td>
            <td>{values.rate}</td>
            <td>{values.amount}</td>
            <td>{values.amountExpected}</td>
            <td>{values.amountPaid}</td>
            <td>{values.loanBalance}</td>
            <td>{values.entryDate}</td>
            <td>{values.endDate}</td>
            <td>{Math.round(values.amount / values.period)}</td>
            <td>{values.details}</td>
            <td>{values.created_at}</td>
        </tr>
    )

    render() {
        const { redirect,redirectSelectedID,mainData,nameSearch,searchAction } = this.state;

        if (redirect) {
            return <Redirect to={{pathname:"/see_clients", state:{redirectSelectedID:redirectSelectedID}}}/>
        }

        let activeLoanDataList = [];
        let myNo = 0
        let totalBalance = 0

        if(mainData !== null){
            const loanData = mainData.loanData
            if(loanData.length>0){
                loanData.forEach((values, i) =>{
                    const hasSearch = nameSearch !== null && nameSearch !== ""
                    const matchesLoan = searchAction ==="LOANID" && values.loanID === nameSearch.toUpperCase()
                    const matchesAccount = searchAction ==="ACCOUNT" && values.member.clubNumber === nameSearch.toUpperCase()

                    if(!hasSearch || matchesLoan || matchesAccount){
                        myNo = myNo+1
                        totalBalance = totalBalance+parseInt(values.loanBalance)
                        activeLoanDataList.push(this.renderLoanRow(values,myNo,i))
                    }
                });
            }else{
                activeLoanDataList.push(
                    <tr key="empty">
                        <td colSpan="17"><br/><Alert color="primary">No data found</Alert></td>
                    </tr>
                )
            }
        }

        return (
            <div>
                <Row className="mainWrraper">
                    <div className="block-header">
                        <h4>VIEW ACTIVE LOANS</h4>
                    </div>
                    <Col xs="12" className="mainWrraper">
                        <ReactJsAlert autoCloseIn ={600000} status={this.state.alertStatus} type={this.state.alertType} title={this.state.alertTitle} Close={() => this.setState({ alertStatus: false })}/>
                        <Col xs="12" md="12" className="tableWrapper">
                            <Row>
                                <Col md="12" xs="12">
                                    <Label className='balB'>TOTAL LOANS: {myNo.toLocaleString()}, TOTAL LOAN BALANCE : {totalBalance.toLocaleString()}</Label>
                                </Col>
                            </Row>
                            <div className='table-container'>
                                <Table striped responsive>
                                    <thead>
                                        <tr>
                                            <th>Action</th>
                                            <th>No.</th>
                                            <th>Loan ID</th>
                                            <th>Member</th>
                                            <th>Member No.</th>
                                            <th>Loan Type</th>
                                            <th>Period(Month)</th>
                                            <th>Rate(%)</th>
                                            <th>Loan Amount</th>
                                            <th>Amount Expected</th>
                                            <th>Amount Paid</th>
                                            <th>Loan Balance</th>
                                            <th>Entry Date</th>
                                            <th>End Date</th>
                                            <th>Installment</th>
                                            <th>Details</th>
                                            <th>Date</th>
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th><Input type="text" className="account" onChange={this.setSearchValue} value={this.state.searchAction ==="LOANID" ?this.state.nameSearch:null} id="LOANID"/></th>
                                            <th></th>
                                            <th><Input type="text" className="account" onChange={this.setSearchValue} value={this.state.searchAction ==="ACCOUNT" ?this.state.nameSearch:null} id="ACCOUNT"/></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    {this.state.isLoading?
                                    <tbody>
                                        <tr>
                                            <td colSpan="17">
                                                <Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Loading...'}
                                            </td>
                                        </tr>
                                    </tbody>:
                                    <tbody>
                                        {activeLoanDataList}
                                    </tbody>}
                                </Table>
                            </div>
                        </Col>
                    </Col>
                </Row>

                <Modal isOpen={this.state.suspendModal} toggle={this.closeSuspendModal}>
                    <ModalHeader toggle={this.closeSuspendModal}>Suspend Loan</ModalHeader>
                    <ModalBody>
                        {this.state.selectedLoan !== null?
                        <div>
                            <FormGroup><Label className="loanLabel"><b>Loan ID:</b> {this.state.selectedLoan.loanID}</Label></FormGroup>
                            <FormGroup><Label className="loanLabel"><b>Member:</b> {this.state.selectedLoan.member.firstName+" "+this.state.selectedLoan.member.lastName}</Label></FormGroup>
                            <FormGroup><Label className="loanLabel"><b>Member No.:</b> {this.state.selectedLoan.member.clubNumber}</Label></FormGroup>
                            <FormGroup><Label className="loanLabel"><b>Loan Amount:</b> {this.state.selectedLoan.amount}</Label></FormGroup>
                            <FormGroup><Label className="loanLabel"><b>Loan Balance:</b> {this.state.selectedLoan.loanBalance}</Label></FormGroup>
                            <FormGroup>
                                <Label className="loanLabel">Reason for suspending*</Label>
                                <Input type="textarea" rows="4" onChange={this.setValue} value={this.state.suspendReason} name="suspendReason"/>
                            </FormGroup>
                        </div>:null}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.closeSuspendModal}>Cancel</Button>
                        <Button color="danger" disabled={this.state.btnDisabled? "disabled":null} onClick={this.suspendLoan}>Suspend Loan</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = state =>({
    userDataStatus : state.mainReducer.dataStatus,
    msg : state.mainReducer.msg,
    userData : state.mainReducer.mainData,
    addMyDataStatus : state.mainReducer.addMyDataStatus,
});

export default connect(
    mapStateToProps,
    {getMainData,addMyData}
)(ActiveLoans)
